import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';

const Facilites = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(true);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_FACILITES = "api/staynest/dashboard/Facilites";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_FACILITES}`, {
            params: {
                offset: pageIndex,
                limit: pageSize
            }
        }).then((data) => {
            setData(data.data);
        });    
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const options = [
        { value: 'add-facility', label: 'Tambah Fasilitas Baru' }
    ];

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between'>
                <h1>Fasilitas</h1>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Tindakan"}
                        options={options}
                        onChange={(value) => {
                            if (value == 'add-facility') {
                                // navigate('/activity-erpppsu/product/new');
                            }
                        }}
                    />
                </div>
            </div>

            
            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTablePageDynamic
                    data={data}
                    nextPage={isNextPage}
                    columns={columns}
                    elementClass="p-1"
                    actions={[]}
                    onDataChange={(pageIndex, pageSize, sortBy) => {
                        fetchData(`${BASE_URL}${PATH_FACILITES}`, {
                            params: {
                                offset: pageIndex,
                                limit: pageSize
                            }
                        }).then((data) => {
                            setIsNextPage(data.more > 0);
                            setData(data.data);
                        });
                    }} />
            )}
        </div>
    );
}

export default Facilites;
